import { MmToCm, RoundOff, GetValueByAction } from '@themes/common/utils';
import { produce } from 'immer';
export const CalculatePoolQuantity = (inputs, product, extra_product_pool_corner, selectedPoolCorner) => {
    var _a, _b, _c;
    const productLength = MmToCm(parseFloat((_a = product.metafields['SB-P']['Length']) !== null && _a !== void 0 ? _a : '1'));
    let corner_size = 0;
    let additional_quantity = 0;
    if (!selectedPoolCorner) {
        corner_size = 0;
        additional_quantity = 4;
    }
    else if (!!extra_product_pool_corner && selectedPoolCorner) {
        const corner_length = MmToCm(parseFloat((_b = extra_product_pool_corner === null || extra_product_pool_corner === void 0 ? void 0 : extra_product_pool_corner.metafields['SB-P']['Length']) !== null && _b !== void 0 ? _b : '0'));
        const corner_width = MmToCm(parseFloat((_c = extra_product_pool_corner === null || extra_product_pool_corner === void 0 ? void 0 : extra_product_pool_corner.metafields['SB-P']['Width']) !== null && _c !== void 0 ? _c : '0'));
        corner_size = Math.abs(corner_length - corner_width) * 2;
    }
    const length = inputs.Length - corner_size;
    const width = inputs.Width - corner_size;
    const length_quantity = Math.ceil(length / productLength) * 2;
    const width_quantity = Math.ceil(width / productLength) * 2;
    const quantity = length_quantity + width_quantity + additional_quantity;
    return quantity > 0 ? quantity : 1;
};
export const changeValues = (key, value, state, product, extra_product_pool_corner, selectedPoolCorner, bagSize, bagDensity, isPool, isBags, isStair, minimumQuantity) => {
    return produce(state, (previousState) => {
        var _a, _b;
        const unit = isBags ? previousState.areaFieds.filter((f) => f.key === key)[0] : previousState.fields.filter((f) => f.key === key)[0];
        let newQty = 1;
        if (isPool) {
            previousState.inputs[key] = value;
            newQty = Math.ceil(value / unit.perQuantity);
            if (key === 'Length' || key === 'Width') {
                newQty = CalculatePoolQuantity(previousState.inputs, product, extra_product_pool_corner, selectedPoolCorner);
                previousState.inputs.PCE = newQty;
            }
        }
        else if (isBags) {
            previousState.inputs[key] = value;
            if (key === 'Width' || key === 'Thickness' || key === 'Length') {
                const area = previousState.inputs['Width'] * previousState.inputs['Length'] * previousState.inputs['Thickness'];
                const m3 = area / 1000000;
                const quantity = (m3 * bagDensity) / bagSize;
                previousState.inputs.M3 = RoundOff(m3);
                newQty = quantity;
                previousState.inputs.PCE = newQty;
            }
            else if (key === 'M3') {
                const quantity = (value * bagDensity) / bagSize;
                previousState.inputs.M3 = value;
                newQty = quantity;
                previousState.inputs.PCE = newQty;
            }
            else if (key === 'PCE') {
                const m3 = (value * bagSize) / bagDensity;
                previousState.inputs.M3 = RoundOff(m3);
                newQty = value;
                previousState.inputs.PCE = newQty;
            }
        }
        else if (isStair) {
            previousState.inputs[key] = value;
            const height = MmToCm(parseFloat((_a = product.metafields['SB-P']['Thickness']) !== null && _a !== void 0 ? _a : '1'));
            const width = MmToCm(parseFloat((_b = product.metafields['SB-P']['Width']) !== null && _b !== void 0 ? _b : '1'));
            const current_length = previousState.inputs['Length'];
            const current_height = previousState.inputs['Height'];
            switch (key) {
                case 'Length':
                    const length_pce = current_length / (width - 3);
                    newQty = length_pce;
                    previousState.inputs.Height = newQty * height;
                    break;
                case 'Height':
                    const height_pce = current_height / height;
                    newQty = height_pce;
                    previousState.inputs.Length = newQty * (width - 3);
                    break;
                case 'DEFAULT':
                    newQty = value / unit.perQuantity;
                    previousState.inputs.Length = newQty * (width - 3);
                    previousState.inputs.Height = newQty * height;
                    break;
                case 'EXTRA':
                    newQty = value / unit.perQuantity;
                    previousState.inputs.Length = newQty * (width - 3);
                    previousState.inputs.Height = newQty * height;
                    break;
            }
            previousState.inputs['DEFAULT'] = newQty;
            if (previousState.inputs['EXTRA'] !== undefined) {
                const currentUnit = previousState.fields.filter((f) => f.key === 'EXTRA')[0];
                previousState.inputs['EXTRA'] = RoundOff(newQty * currentUnit.perQuantity);
            }
        }
        else {
            newQty = value / unit.perQuantity;
            for (const inputKey in previousState.inputs) {
                const unit = previousState.fields.filter((f) => f.key === inputKey)[0];
                previousState.inputs[inputKey] = inputKey === key ? value : RoundOff(newQty * unit.perQuantity);
            }
        }
        previousState.qty = Math.ceil(newQty);
        previousState.rawQuantity = newQty;
    });
};
export const handleInputChange = (key, currentVal, changeValuesFn) => {
    var _a;
    const value = parseFloat((_a = currentVal === null || currentVal === void 0 ? void 0 : currentVal.toString()) !== null && _a !== void 0 ? _a : '0');
    changeValuesFn(key, value);
};
export const handleButtonAction = (key, action, inputs, changeValuesFn) => {
    var _a, _b;
    const value = GetValueByAction(parseFloat((_b = (_a = inputs[key]) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '0'), action);
    const effectiveValue = Math.max(value, action === 'subtract' ? 0.1 : value);
    changeValuesFn(key, effectiveValue);
};
